import { render, staticRenderFns } from "./PropertiesCommercial.vue?vue&type=template&id=65ec5b98&scoped=true"
import script from "./PropertiesCommercial.vue?vue&type=script&lang=ts"
export * from "./PropertiesCommercial.vue?vue&type=script&lang=ts"
import style0 from "./PropertiesCommercial.vue?vue&type=style&index=0&id=65ec5b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec5b98",
  null
  
)

export default component.exports